import { BusEvent } from '@web/common';

export class WarehouseLocalizationChangedBusEvent extends BusEvent {}
